import { render, staticRenderFns } from "./Referral.vue?vue&type=template&id=a0101152&scoped=true&"
import script from "./Referral.vue?vue&type=script&lang=js&"
export * from "./Referral.vue?vue&type=script&lang=js&"
import style0 from "./Referral.vue?vue&type=style&index=0&id=a0101152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0101152",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0101152')) {
      api.createRecord('a0101152', component.options)
    } else {
      api.reload('a0101152', component.options)
    }
    module.hot.accept("./Referral.vue?vue&type=template&id=a0101152&scoped=true&", function () {
      api.rerender('a0101152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Referral.vue"
export default component.exports